// extracted by mini-css-extract-plugin
export default {"products":"Uu-z","card":"Vu-z","oosMessaging":"Wu-z"};